import { render, staticRenderFns } from "./promotionSelectPro.vue?vue&type=template&id=2de025fa&"
import script from "./promotionSelectPro.vue?vue&type=script&lang=js&"
export * from "./promotionSelectPro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports